import { socialApiClient } from '@/shared/api-client/social-api-client';

export async function ExportCampaignPosts(
  campaignId: string,
  signal?: AbortSignal,
): Promise<string> {
  const response = await socialApiClient.post(`campaigns/${campaignId}/exports/posts`, {
    signal,
  });
  return await response.text();
}
